module.exports = __webpack_public_path__ + "img/logo_white.52f0574d.png";